module.exports = __webpack_public_path__ + "img/icon_pig_count_white.7c7362fe.svg";